import React, { useEffect, useState } from 'react';
import { Form, Col, Button, Row, ProgressBar, Image, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { Eye, Trash2, ArrowRight, Plus } from 'lucide-react';
import callAPI from '../../../commonservices/APIRequests';
import { checkFileFormat, encrypt, fileToBase64, payloadFileFormat, viewDocument } from '../../../commonservices/CommonMethods';
import Toaster from '../../Shared/Toaster/Toaster';
import Loader from '../../Shared/Loader/Loader';
import QRCode from 'qrcode.react';
import { io } from 'socket.io-client';
import '../NewOnBoarding.css';
import eyeIcon from '../../../assets/images/Action-Icons/Eye-Icon.svg'
import deleteIcon from '../../../assets/images/Icons/delete-icon.svg'
import InfoIcon from '../../../assets/images/info-icon-v2.svg'

let socket;

const Attachments = (props) => {

    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const url = window.location.origin + '/QRAttachments?userId=' + encrypt(props.dealerId) + '&requestedFacilityAmount=' + props.requestedFacilityAmount + '&partnerLogo=' + partnerDetails.partnerLogo;

    const [showLoader, setShowLoader] = useState(false);
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    });

    const [loadingText, setLoadingText] = useState('');
    const [docLoaders, setDocLoaders] = useState({
        dealersLicense: false,
        businessLicense: false,
        driversLicense: false,
        dealershipInsurance: false,
        dealerBond: false,
        bankStatements: false,
        floorPlanRecievables: false,
        lotPhoto: false,
        voidedCheck: false,
        personalGuarantorTaxReturn: false,
        businessTaxReturns: false,
        additionalDocs:false,
        ytdFinancialStatements:false,
        financialYears:false
    });

    useEffect(() => {

        socket = io(window.location.origin, { path: '/sopraData/socket.io', autoConnect: false, transports: ['websocket','polling'], reconnectionAttempts: 5 });

        socket.connect();

        socket.on("uploadedFiles", (argUserId, argDocumentName) => {
            if (argUserId === props.dealerId && Object.keys(docLoaders).includes(argDocumentName)) {
                setDocLoaders({
                    ...docLoaders,
                    [argDocumentName]: true
                });
                setLoadingText('Uploading...');
                props.getData(false, false);
                setTimeout(() => {
                    setDocLoaders({
                        ...docLoaders,
                        [argDocumentName]: false
                    })
                }, 2000);
            }
        });

        socket.on("deletedFiles", (argUserId, argDocumentName) => {
            if (argUserId === props.dealerId && Object.keys(docLoaders).includes(argDocumentName)) {
                setDocLoaders({
                    ...docLoaders,
                    [argDocumentName]: true
                })
                setLoadingText('Deleting...');
                props.getData(false, false);
                setTimeout(() => {
                    setDocLoaders({
                        ...docLoaders,
                        [argDocumentName]: false
                    })
                }, 2000);
            }
        });

        return () => {
            socket.disconnect();
        }

    }, []);

    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    };

    const uploadFile = async (event, key) => {
        
        event.preventDefault();
        event.stopPropagation();

        const file = event.target.files[0];

        if (!file)
            return;

        if (file.size > 10485760) {
            setToaster({
                header: 'Error',
                class: 'error-toaster',
                content: 'File size is too large, please upload a file smaller than 10MB.',
                showToaster: true
            });
            return;
        }

        if (key == 'bankStatements' && file?.name?.toLowerCase().substring(file?.name?.lastIndexOf('.')) !== '.pdf') {
            setToaster({
                header: 'Warning',
                class: 'warning-toaster',
                content: 'Bank statements must be in PDF format.',
                showToaster: true
            });
            return;
        }

        const isValid = checkFileFormat(file, setToaster, ['.pdf', '.jpg', '.jpeg', '.png', '.heic']);

        if (!isValid) {
            // Stop further execution because the file format is invalid
            return;
        }

        //Hardcoded mime type for heic files since html can't doesn't support heic files and file handler has its file type empty.


        const req = {
            documentType: key,
            document: {
                fileName: file.name,
                base64Image: await fileToBase64(file),
                fileType: payloadFileFormat(file.name, file.type)
            }
        }

        if (sessionStorage.getItem('tempDealerId'))
            req.dealer_id = sessionStorage.getItem('tempDealerId');

        setShowLoader(true);

        return callAPI.post('/auth/api/v1/dealer/uploadDocumentWithoutVIN', req)
            .then((response) => {

                if (response.status === 200) {

                    const data = { ...props.attachmentsDetails };

                    data[key].docs.push({ ...req.document, _id: response.data.documentId, });

                    props.twoWayBind(key, data[key]);

                    event.target.value = null;

                    setShowLoader(false);

                }
                else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    });
                    setShowLoader(false);

                }

            })

    }

    const deleteDoc = (event, key, index = 0) => {

        event.preventDefault();
        event.stopPropagation();

        const data = { ...props.attachmentsDetails };

        setShowLoader(true);

        const req = {
            documentId: data[key].docs[index]._id
        }

        if (sessionStorage.getItem('tempDealerId'))
            req.dealer_id = sessionStorage.getItem('tempDealerId');

        return callAPI.delWithParams('/vehicle/api/v1/dealers/deleteDocument', req)
            .then((response) => {

                if (response.status === 200) {

                    data[key].docs = data[key].docs.filter((item, itemIndex) => itemIndex != index);
                    props.twoWayBind(key, data[key]);
                    setShowLoader(false);

                }
                else {
                    setShowLoader(false);

                }

            })

    }

    return (<React.Fragment>
        {
            toaster.showToaster ?
                <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                : null
        }
        <Loader show={showLoader} styleType='fixed' />

        <Form className="text-left">
            <div className='onboarding-form-box-modal'>
                {!props.documentsSectionOnly ? <React.Fragment>
                    <h1>Attachments</h1>
                    <p className="secondary-text-color">Please upload the following documents that you have<br />
                        Max file size: 10MB<br />
                    </p>
                </React.Fragment> : <h1>Upload Missing Documents</h1>}
                <div className='mt-3 d-flex '>
                    <Col className='px-0 attachments-form-group'>

                        {
                            Object.keys(props.attachmentsDetails).filter(item => !['_id', 'selectedTab'].includes(item)).map(doc => {

                                if (props.requestedFacilityAmount < 500000 && ['additionalDocs', 'financialYears', 'ytdFinancialStatements','personalGuarantorTaxReturn', 'businessTaxReturns'].includes(doc))
                                    return null;

                                return (<div>
                                    <div className='d-flex align-items-center'>
                                        <Form.Group controlId="formBasicPhone1" className='position-relative'>
                                            <div className="mw-400px d-flex align-items-center">
                                                <div className="attachments-upload-wrapper mr-2">
                                                    <React.Fragment>
                                                        <span className='d-flex align-items-center'>
                                                            <span className='mr-1'><Plus size={16} /></span>
                                                            <span>Attach</span>
                                                            {props.attachmentsDetails[doc].isMultiple || (props.attachmentsDetails[doc].docs.length === 0) ? <input type="file" onChange={(event) => uploadFile(event, doc)} id="input-file-now" accept='.pdf,.heic,.jpg,.png,.jpeg' /> : <input type="file" disabled id="input-file-now" />}
                                                        </span>
                                                    </React.Fragment>
                                                </div>
                                                <span className='d-flex'>
                                                    <p className= { ['rsm summary', 'ytd financial statements']?.includes(props?.attachmentsDetails[doc]?.label?.toLowerCase()) ? 'secondary-text-color' : 'secondary-text-color sentence-case'} style={{ fontWeight: props.attachmentsDetails[doc].docs.length > 0 ? 700 : null }}>{props?.attachmentsDetails[doc]?.label} </p>  
                                                    <span className={`text-transform-unset d-flex`}>
                                                        <OverlayTrigger key="right" placement="bottom-start"
                                                            overlay={
                                                                <Popover>
                                                                    <Popover.Content>
                                                                        <span>Allowed types: {`${props?.attachmentsDetails[doc]?.label == '3 Months Bank Statements' ? 'PDF' : 'PDF, JPG, JPEG, PNG, HEIC'}`}</span>
                                                                    </Popover.Content>
                                                                </Popover>
                                                            }>
                                                            <Image src={InfoIcon} alt='info' className='common-info-icon ml-1 file-info-icon' />
                                                        </OverlayTrigger>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='mt-1'>
                                                {
                                                    props.attachmentsDetails[doc].docs.map((document, index) =>
                                                        <p className="attachedfile-name content-text-14px pl-0 mb-0">
                                                            <span className="secondary-text-color"> {(doc === 'dealersLicense' ? 'dealershipLicense' : doc) + ' - ' + document.fileName} </span>
                                                            <OverlayTrigger placement="bottom"
                                                                overlay={
                                                                    <Tooltip>View</Tooltip>}>
                                                                <Image width={15} src={eyeIcon} className='cursor-pointer mx-2' onClick={() => viewDocument(document.fileType, document.base64Image)} />
                                                            </OverlayTrigger>
                                                            {!props.documentsSectionOnly ? <OverlayTrigger placement="bottom"
                                                                overlay={
                                                                    <Tooltip>Delete</Tooltip>}><Image width={13} src={deleteIcon} className='cursor-pointer' onClick={(event) => deleteDoc(event, doc, index)} /></OverlayTrigger> : null}
                                                        </p>)
                                                }
                                            </div>
                                            {docLoaders[doc] ? <div className='mobile-upload-progress'>
                                                <ProgressBar animated now={100} label={loadingText} />
                                            </div> : null}
                                        </Form.Group>

                                    </div>
                                </div>)

                            })
                        }

                    </Col>


                    <Col className='hide-qr-code' md={'auto'}>
                        <Form.Group className='text-center' controlId="formBasicPhone1">
                            {/* <Form.Label className="label-color text-left display-block">Upload files from mobile by scanning below QR</Form.Label> */}
                            <div className="mb-2 py-3">
                                <QRCode value={url} />
                                <p className='mw-130px'>To upload files from your mobile device scan here</p>
                            </div>
                        </Form.Group>
                    </Col>
                </div>

            </div>
            {!props.documentsSectionOnly ?
                <div className='my-4'>
                    <p>If you dont have all documents now you can always return and upload them later</p>
                </div> : null
            }
            {!props.documentsSectionOnly ?
                <div>
                    <Button type="button" variant="outline-secondary" onClick={(event) => props.submit(event, null, true)} className="default-btn">Previous</Button>
                    <Button className="default-btn ml-3" type="button" onClick={(event) => props.submit(event, null, false, true)} variant="primary">Next</Button>
                </div> : null
            }

        </Form>
    </React.Fragment>)
}

export default Attachments;